import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import {
  Input,
  Radio,
  SearchInput,
  Textarea,
} from "../../../../ui/inputs/Input";

export default function DesincorporacionBienesInmuebles({
  show,
  setShow,
  setTabla,
}) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Incorporación Bienes Inmuebles</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>

        <ul className="nav d-flex flex-wrap gap-1 align-items-center" id="ex-with-icons" role="tablist">
          
          
          <li className="nav-item " role="presentation">
            <a

              className="nav-link active bg-blue-100 text-light rounded h-100"
              id="nav-datosGenerales-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-datosGenerales"
              type="button"
              role="tab"
              aria-controls="nav-datosGenerales"
              aria-selected="true"
            >
              Datos Generales
            </a>
          </li>

          <li className="nav-item " role="presentation">
            <a

              className="nav-link bg-blue-200 text-light rounded h-100"
              id="nav-caracteristicasInmueble-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-caracteristicasInmueble"
            type="button"
            role="tab"
            aria-controls="nav-caracteristicasInmueble"
            aria-selected="false"
            >
              Características del Inmueble
            </a>
          </li>

          <li className="nav-item " role="presentation">
            <a
              className="nav-link bg-blue-300 text-light rounded h-100"
              id="nav-linderos-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-linderos"
              type="button"
              role="tab"
              aria-controls="nav-linderos"
              aria-selected="false"
            >
             Línderos
            </a>
          </li>
          
          <li className="nav-item " role="presentation">
            <a
              className="nav-link bg-blue-400 text-light rounded h-100"
              id="nav-costos-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-costos"
              type="button"
              role="tab"
              aria-controls="nav-costos"
              aria-selected="false"
            
            >
              Costos
            </a>
          </li>

          <li className="nav-item " role="presentation">
            <a
              className="nav-link bg-blue-500 text-light rounded h-100"
              id="nav-datosDesincorporacion-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-datosDesincorporacion"
              type="button"
              role="tab"
              aria-controls="nav-datosDesincorporacion"
              aria-selected="false"
            
            >
              Datos de la Desincorporación
            </a>
          </li>

        </ul>

        <div className="tab-content mt-2" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-datosGenerales"
            role="tabpanel"
            aria-labelledby="nav-datosGenerales-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-2 m-0 mb-2 p-0">
                <Input label="Id Sistema:" />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <SearchInput label="Código Bien:" />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input label="Id. Tipo Activo:" />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input label="Descripción:" />
              </div>
              <div className="col-9 m-0 p-0">
                <Input label="Tipo Material:" />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label="Fecha Incorporación:" type="date" />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Orden Pago
                </legend>
                <div className="col-3 m-0 mb-2 p-0">
                  <SearchInput label="Cod. Orden Pago:" />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input label="Factura:" />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input label="Fecha Adquisición:" type="date" />
                </div>
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-3 m-0 p-0">
                    <SearchInput label="Cod. Proveedor:" />
                  </div>
                  <div className="col-3 m-0 p-0 pl-2">
                    <Input label="C.I. / RIF:" />
                  </div>
                  <div className="col-6 m-0 p-0 pl-2">
                    <Input label="Nombre / Razón Social:" />
                  </div>
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Datos de la Ubicación
                </legend>
                <div className="col-2 m-0 p-0">
                  <SearchInput label="Cod. Ubicación:" />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Input label="Descripción:" />
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <Input label="Dirección:" />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Vida Útil
                </legend>
                <div className="col-3 m-0 p-0">
                  <Input label="Original:" />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="+" />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="-" />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="Actual:" />
                </div>
              </fieldset>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-caracteristicasInmueble"
            role="tabpanel"
            aria-labelledby="nav-caracteristicasInmueble-tab"
            tabindex="0"
          >
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Mueble
              </legend>
              <div className="col-6 m-0 mb-2 p-0">
                <Input label="Código del Bien:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label="Código Bienes Nacionales:" />
              </div>
              <div className="col-8 m-0 mb-2 p-0">
                <Input label="Denominación:" />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input label="Numero Expediente:" />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input label="Detalle:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Avaluo Actual:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Avaluo Comisión:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label="Clasificación Funcional:" />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input label="Estado Legal Contrucción:" />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea label="Observación:" style={{ height: 70 }} />
              </div>
              <div className="col-4 m-0 p-0 d-flex gap-2">
                <span className="fw-bold">Registro Inmueble:</span>
                <div className="col-auto m-0 p-0">
                  <Radio label="Propio" name="registroInmueble" id="propio" />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio
                    label="Arrendado"
                    name="registroInmueble"
                    id="arrendado"
                  />
                </div>
              </div>
              <div className="col-8 m-0 p-0 pl-2">
                <Input label="Período de Arrendamiento:" />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex gap-2  border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Responsable Patrimonial
              </legend>
              <div className="col-3 m-0 p-0">
                <Input label=" Cédula de Identidad:" />
              </div>
              <Input label="Nombre del Responsable:" />
            </fieldset>
          </div>
          <div
            className="tab-pane fade"
            id="nav-costos"
            role="tabpanel"
            aria-labelledby="nav-costos-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Valor Inicial:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Valor Rescate:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depressiación Mensual:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depresiación Acumulada:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Valor Libros:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Adición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Reexpresado:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Costo Reposición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                />
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-linderos"
            role="tabpanel"
            aria-labelledby="nav-linderos-tab"
            tabindex="0"
          >
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">Línderos</legend>
              <div className="col-3 m-0 p-0">
                <Textarea label="Norte:" style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Textarea label="Sur:" style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Textarea label="Este:" style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Textarea label="Oeste:" style={{ height: 70 }} />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">Areas</legend>
              <div className="col-3 m-0 p-0">
                <Input label="Area Terreno:" />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label="Area Contrucción:" />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label="Area Cubierta:" />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label="Otras Instalaciones:" />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
              <legend className="float-none w-auto m-0">Disposición</legend>
              <div className="col-3 m-0 p-0">
                <SearchInput label="Cod. Motivo:" />
              </div>
              <Input label="Descripción:" />
            </fieldset>
          </div>
          <div
            className="tab-pane fade"
            id="nav-datosDesincorporacion"
            role="tabpanel"
            aria-labelledby="nav-datosDesincorporacion-tab"
            tabindex="0"
          >
            <fieldset className="col-12 m-0 p-2 border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Mueble
              </legend>
              <div className="col-3 m-0 p-0">
                <Input label="Fecha Desincorporación:" type="date" />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                <legend className="float-none w-auto m-0">Disposición</legend>
                <div className="col-3 m-0 p-0">
                  <SearchInput label="Cod. Motivo:" />
                </div>
                <Input label="Descripción:" />
              </fieldset>
              <div className="col-12 m-0 mt-2 p-0">
                <Textarea label="Observación:" style={{ height: 70 }} />
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton onClick={salir} >Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
